import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry on the browser. Skips silently in dev or when
 * REACT_APP_SENTRY_DSN is not configured. Call once from the entry point
 * before rendering the React tree so route-level errors are captured.
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
  });
}

export { Sentry };
